var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const ChatPublic = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M9 12.0833C9.68409 13.0954 10.7732 13.75 12 13.75C13.2268 13.75 14.3159 13.0954 15 12.0833M9.75 8.75H9.75735M14.25 8.75H14.2573M4 10.75C4 4.75 5.5 4.25 12 4.25C18.5 4.25 20 4.75 20 10.75C20 15.8671 18.909 16.9838 14.5557 17.2016C13.2802 18.3846 10.8901 20.25 8.5 20.25L9.2645 17.192C5.0609 16.9519 4 15.7959 4 10.75Z", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
